<template>
  <div>
    <button type="button" class="btn btn-sm btn-secondary" @click="showModalAgregarFactura"
      v-if="current.estado == 'A'">
      <i class="fa fa-plus"></i>
      Agregar pago
    </button>

    <div aria-hidden="true" class="modal fade" id="modalAgregarFactura" role="dialog" tabindex="-1">
      <div class="modal-dialog modal-xl" role="document" style="max-width: 100%;">
        <div class="modal-content modal-xl" style="max-width: 100%;">
          <div class="modal-header faded smaller">
            <h5 class="modal-title">Facturas con Saldo</h5>
            <button aria-label="Close" class="close" data-dismiss="modal" type="button">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-sm-4">
                <div class="text-center">
                  <h6 class="text-center text-dark">Total de Saldo de Cliente</h6>
                  <div v-if="current.saldo_pendiente">
                    <h4 class="text-danger">{{ formatDecimalCurrency(current.saldo_pendiente) }}</h4>
                  </div>
                </div>
              </div>
              <div class="col-sm-4">
                <div class="text-center">
                  <h6 class="text-center text-dark">Total Facturas a Pagar</h6>
                  <div>
                    <h4 class="text-success">{{ formatDecimalCurrency(current.total_facturas) }}</h4>
                  </div>
                </div>
              </div>
              <div class="col-sm-4">
                <div>
                  <h6 class="text-center text-dark">Total Pagado Agregado</h6>
                  <div>
                    <h4 class="text-center text-success">{{ formatDecimalCurrency(current.total_pagado) }}</h4>
                  </div>
                </div>
              </div>
              <div class="col-12">
                <div class="table-responsive">
                  <div class="table-responsive tableFixHead">
                    <table class="table table-striped">
                      <thead>
                        <tr>
                          <th style="width: 8%">Nit</th>
                          <th>Nombre</th>
                          <th>Dirección</th>
                          <th>Documento</th>
                          <th style="width: 10%">Fecha</th>
                          <th class="text-right">cargos</th>
                          <th class="text-right">abonos</th>
                          <th class="text-right">Saldo</th>
                          <th class="text-right">Acumulado</th>
                          <th class="text-right"></th>
                        </tr>
                      </thead>
                      <tbody style="max-height: 400px;">
                        <tr v-for="item in facturas_con_saldo" :key="item.id">
                          <td>{{ item.nit }}</td>
                          <td>{{ item.nombre }}</td>
                          <td>{{ item.direccion }}</td>
                          <td>{{ item.documento }}</td>
                          <td>{{ item.fecha }}</td>
                          <td class="text-right">{{ formatDecimalCurrency(item.cargos) }}</td>
                          <td class="text-right">{{ formatDecimalCurrency(item.abonos) }}</td>
                          <td class="text-right">{{ formatDecimalCurrency(item.saldo) }}</td>
                          <td class="text-right">{{ formatDecimalCurrency(item.acumulado) }}</td>
                          <td class="text-right">
                            <button @click="agregarFactura(item)" type="button"
                              class="btn btn-secondary btn-sm">Agregar</button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <!-------------------- END - Basic Table -------------------->
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-secondary" ref="cerrarModal" data-dismiss="modal" type="button">
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import _ from "lodash";
import Notifications from "@/notifications/notifications";
import ClientesSelectComponent from "@/components/commons/ClientesSelectComponent";
import DynamicService from "@/services/commons/DynamicService";
import TiendaSelectComponent from "@/components/commons/TiendaSelectComponent";

export default {
  components: {
    ClientesSelectComponent,
    TiendaSelectComponent,
  },
  props: {
    current: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      _current: {},
      caja: "",
      facturas_con_saldo: [],
    };
  },
  mounted() { },
  methods: {
    formatDecimalCurrency(valor) {
      return 'Q ' + valor.toLocaleString('es-GT', { maximumFractionDigits: 2, minimumFractionDigits: 2 })
    },
    showModalAgregarFactura() {
      let self = this;
      self.refreshFacturasConSaldo(self.current.cliente.nit);
      $("#modalAgregarFactura").modal();
    },
    refreshFacturasConSaldo(nit_cliente) {
      let self = this;
      if (!nit_cliente) {
        return;
      }
      DynamicService.getAction(
        "cat",
        "clientes",
        nit_cliente,
        "estado_cuenta",
        { solo_con_saldo: 1 }
      )
        .then((response) => {
          self.facturas_con_saldo = response.data.estado_cuenta;
        })
        .catch((err) => { });
    },
    agregarFactura(factura) {
      let self = this;
      DynamicService.postAction(
        "cxc",
        "cobros",
        self.current.id,
        "agregar_factura",
        {
          cargo_e: factura.id
        }
      ).then((response) => {
        {
          Notifications.alert.success(
            "Adición de Factura al Cobro",
            "¡se ha realizado exitosamente!"
          );
          $("#modalAddDetailReqCompra").modal("hide");
          self.$emit("refreshData");
        }
      }).catch((error) => {
        self.current.errors = error.response.data;
        Notifications.alert.error(
          "Adición de Factura",
          self.current.errors.cargo_e
        )
      });;
    },
    cerrandoModal() {
      this.$emit("cerrandomodal");
    },
  },
};
</script>
